import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable, map, tap } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { Contact } from "@app/core/contact/domain/contact";
import { WhatsappContactMapper } from "@app/core/contact/data/whatsapp-contact.mapper";

@Injectable({
  providedIn: "root",
})
export class GetContactWhatsappNumberWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(): Observable<string> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.GET_CONTACT_WHATSAPP_NUMBER_ENDPOINT())
      .setMethod(HttpMethod.get)
      .build();

    return this.baseHandler
      .execute(parameters)
      .pipe(
        map((response: { phone: string }) =>
          WhatsappContactMapper.removeSpaces(response.phone)
        )
      );
  }
}
